var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"content-field"},[_c('v-col',{staticClass:"py-0",attrs:{"sm":"4"}},[_c('p',[_vm._v(_vm._s(_vm.label)+":")])]),_c('v-col',{staticClass:"py-0",attrs:{"sm":"8"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }